import styled from '@emotion/styled'

export const LoginFormStyled = {
  Container: styled.div<any>`
  `,
  Separator: styled.div<any>`
    margin-top: 29px ;
  `,
  ContainerButton: styled.div<any>`
    display: flex;
    justify-content: center;
    margin-top: 29px;
    margin-bottom: 29px;
  `,
};
